import ReactTable from "react-table";
import {I18n} from "../../../../I18n/components/loan";
import React from "react";
import {Button} from "reactstrap";

const LoanSummaryPropertyList = props => {
    const {lang, summaryProps} = props;
    const tableData = summaryProps.map((property) => {
        const bank = property.bank;
        const maxNumberOfPayments = property.maxNumberOfPayments;
        return {
            bankIntegration: bank.integration,
            bankName: bank.name,
            bankPropsInitialised: property.bankPropsInitialised,
            maxNumberOfPayments: maxNumberOfPayments ? maxNumberOfPayments : I18n[lang].notSpecified,
            actions: (
                <div>
                    <Button
                        className="ml-2"
                        onClick={() => props.onItemClick(bank.integration)}
                        color="inverse"
                        size="sm"
                        round="true"
                        icon="true"
                    >
                        <i className="fa fa-edit"/>
                    </Button>
                </div>
            )
        };
    });
    return (
        <div className="MyReactTableClass">
            <ReactTable
                getProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            border: "none",
                            padding: "5px 0"
                        }
                    };
                }}
                getTheadProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            boxShadow: "none",
                            padding: "10px 0",
                            fontWeight: "600"
                        }
                    };
                }}
                getTheadThProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none"
                        }
                    };
                }}
                getTdProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            borderRight: "none",
                        }
                    };
                }}
                getTrProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            cursor: "pointer",
                            alignItems: "center"
                        }
                    };
                }}
                getNoDataProps={(state, rowInfo, column, instance) => {
                    return {
                        style: {
                            top: "100%"
                        }
                    };
                }}
                columns={[
                    {
                        Header: `${I18n[lang].bank}`,
                        accessor: "bankName",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: `${I18n[lang].bankPropsInitialised}`,
                        accessor: "bankPropsInitialised",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        },
                        Cell: row => (
                            <i className={row.value ? "fa fa-check" : "fa fa-times"}/>
                        )
                    },
                    {
                        Header: `${I18n[lang].maxNumberOfPayments}`,
                        accessor: "maxNumberOfPayments",
                        sortable: false,
                        filterable: false,
                        minWidth: 100,
                        style: {
                            textAlign: "center",
                            fontSize: "0.8rem",
                        }
                    },
                    {
                        Header: "",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                        minWidth: 30,
                        style: {
                            textAlign: "right",
                        }
                    },
                ]}
                className="-highlight"
                data={tableData}
                defaultPageSize={tableData.length}
                showPaginationBottom={false}
                filterable
            />
        </div>
    )
};

export default LoanSummaryPropertyList;


// WEBPACK FOOTER //
// ./src/components/Loan/Property/Summary/LoanSummaryPropertyList.js